<template>
    <div>
        <div class="breadcrumbs">
            <div class="col-sm-4">
                <div class="page-header float-left">
                    <div class="page-title">
                        <h1>오더 정보 동기화</h1>
                    </div>
                </div>
            </div>            
        </div>        
        <b-container fluid class="animated fadeIn">
            <div class="card">
                <div class="card-header">
                    <strong class="card-title">로지 오더 정보 동기화</strong>
                </div>
                <b-card-body>
                    
                    <div class="ml-3 float-right">                        
                        <b-form-file v-model="file" ref="excel_file" :state="Boolean(file)" placeholder="엑셀파일등록" @change="_change" accept=".xls, .xlsx"></b-form-file> 
                    </div>                   
                    <b-table 
                        show-empty
                        empty-text="조회된 내용이 없습니다."
                        empty-filtered-text="조회된 내용이 없습니다."
                        fixed="fixed"
                        responsive="sm" 
                        :small="true"                          
                        :striped="false" 
                        :bordered="true"  
                        hover                                 
                        :items="items" 
                        :fields="fields">                                                                                   
                    </b-table>
                    <div class="mb-1 mt-2 float-right" v-if="items.length > 0">
                        <b-row align-h="end" align-v="center">
                            <b-col  md="auto">
                                <b-button class="mb-2" size="" variant="primary" @click="syncOrders">동기화</b-button>
                            </b-col>
                            <b-col md="auto">
                                <download-excel
                                    name = '등록오류건.xls'
                                    :data   = items
                                    :fields = "json_fields">                            
                                    <img src="/static/images/download-to-excel-icon-0.jpg" width="50" height="50" alt="">
                                </download-excel>
                            </b-col>
                        </b-row>                                                
                    </div>                    
                </b-card-body>
            </div>            
        </b-container>    
    </div>
</template>
<script>
import {logiOrder} from '../data/table.js'
import employeeApi from '../api/employee'
import ResultMessage from '../data/resultMessage'
import kakaoApi from '../api/kakao'
import {mapGetters} from 'vuex'
import _ from 'lodash'
import JsonExcel from 'vue-json-excel'
import XLSX from 'xlsx';
import * as types from '../store/mutation-types'

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x,i) => ({name:XLSX.utils.encode_col(i), key:i}));
const sleep = ms => new Promise(r => setTimeout(r, ms));

export default {
    name: 'syncOrder',
    components: {        
        //Datepicker
        //'ag-grid-vue': AgGridVue
        'downloadExcel': JsonExcel
    },
    data() {
        return {
            fields: logiOrder.fields,
            items: [],    
            tempItems: [],        
            currentPage: 1,
            perPage: 5,
            totalRows: 0,
            filter: null,
            department: null,
            isModify: false,
            state: {
                tickets:[{name:"test"}],
                headers:["Test header"]
            },
            file: null,
            data: [],
            json_fields: {
                '상태' : 'state',
                '로지접수번호' : 'logiOrderNo',
                '고객명' : 'customerName',
                '접수일시' : 'regDate',
                '출발지' : 'startAddr',
                '도착지' : 'endAddr',
                '기사소속' : 'driverCompany',
                '기사명' : 'driverName',
                '완료시간' : 'endDate',
                '로켓오더번호' : 'orderNo'
            }
        }
    },
    computed: mapGetters({
        userAccount: 'userAccount/userAccount'                
    }),
    methods: {
        goBack: function() {
            this.$router.go(-1);
        },
             
        _change(evt) {
            // this.$refs.excel_file.reset();
            const files = evt.target.files;            
            if(files == false && files[0] == false) 
                this.$refs.excel_file.reset();
            if(files && files[0])
                this._file(files[0]);
                
        },
        _change_new(evt) {
            const files = evt.target.files;            
            if(files == false && files[0] == false) 
                this.$refs.excel_file.reset();
            if(files && files[0])
                this._file_new(files[0]);
        },
        _file(file) {
			/* Boilerplate to set up FileReader */
			const reader = new FileReader();
			reader.onload = (e) => {
				/* Parse data */
				const bstr = e.target.result;
				const wb = XLSX.read(bstr, {type:'binary', raw: true});
				/* Get first worksheet */
				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];
				/* Convert array of arrays */
                const data = XLSX.utils.sheet_to_json(ws, {header:1, blankrows: false});                
                /* Update state */
                if(this.makeItems(data.slice(1)) == false) {                    
                    alert('필수 항목을 확인 해 주세요');
                    this.file = null;
                    this.itmes = [];
                    this.$refs.excel_file.reset();
                    return;
                }                    				
			};
            reader.readAsBinaryString(file);
            
        },
        makeItems: function(data) {
            if(data == false) return false;
                    
            const vendorNo = 12002;
            const type = 10092;
            const gendor = 'M';            
            
            const tempItems = [];
            for(let i = 0; i < data.length; i++) {
                let item = data[i];
                console.log("rocket order no :: " + item[43]);
                if(item[43] == false || item[43] == undefined)
                    continue;
              
                if(Number.isInteger(parseInt(item[43])) == false)
                    continue;
                let jsonItem = {};                                
                jsonItem.state = item[2];
                jsonItem.logiOrderNo = item[9];
                jsonItem.customerName = item[14];
                jsonItem.regDate = item[16];
                jsonItem.startAddr = item[17];
                jsonItem.endDate = item[20];
                jsonItem.driverCompany = item[22];
                jsonItem.driverName = item[23];
                jsonItem.endDate = item[28];
                jsonItem.orderNo = item[43];            
                tempItems.push(jsonItem);                
            }
            this.items = tempItems;
            
            return true;
        },
        syncOrders: async function(items) {
            if(confirm('총 ' + this.items.length + ' 건의 오더를 동기화 하시겠습니까?') == false) return;
            this.$store.commit('common/' + types.Common.SPINNER_STATE, true);
            let resultMessage = new ResultMessage(); 
            for(var i = 0; i < this.items.length; i++) {                
                await this.syncOrder(this.items[i]);
                // await sleep(100);                    
            }            
            
            this.items = this.tempItems;  
            this.$forceUpdate();             
            this.$store.commit('common/' + types.Common.SPINNER_STATE, false);           
        },
        syncOrder: async function(item) {
            let tempItem = {};
            let resultMessage = new ResultMessage();
            try{               
                tempItem = await employeeApi.syncOrder(item); 
                resultMessage.buildSuccessMessage(tempItem);                
                tempItem = resultMessage.payload;
                console.log(tempItem);              
            } catch(e) {
                tempItem = item;
                tempItem.syncResult = '등록실패';
                               
            }
            this.tempItems.push(tempItem); 
        }
    },
    mounted: function() {
        // 최초 로딩 데이터 조회
        // this.departmentList();
    }
}
</script>




// WEBPACK FOOTER //
// src/components/SyncOrder.vue